export default {
      id: "oc-zizhanghao-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite.svg#oc-zizhanghao",
      toString: function () {
        return this.url;
      }
    }